window.switchLayout = function (layout) {
  // display requested layout
  const layouts = Array.from(document.getElementsByClassName('c-layout'));

  layouts.forEach(l => l.classList.add('hidden'));
  document.getElementById(layout).classList.remove('hidden');

  // reinitilize scripts
  window.simpleMapInit();
};
